"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var city_1 = tslib_1.__importDefault(require("./city"));
var state_1 = tslib_1.__importDefault(require("./state"));
var AddressResource = /** @class */ (function (_super) {
    tslib_1.__extends(AddressResource, _super);
    function AddressResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AddressResource.endpoint = '/addresses';
    AddressResource.MODEL_NAME = 'address';
    AddressResource.related = {
        city: city_1.default,
        state: state_1.default
    };
    return AddressResource;
}(base_1.default));
exports.default = AddressResource;
//# sourceMappingURL=address.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/address.js
// module id = B9+o
// module chunks = 0